var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box1"},[_c('img',{attrs:{"src":require("../../../assets/imgs/img/geren-SVG/Slice-34.svg"),"alt":""}}),_c('p',[_vm._v("没有权限查看本页面，请联系管理员")])])
}]

export { render, staticRenderFns }